import { InterestUser } from './User'
import { InterestContent } from './Content'

export const InterestDetail = {
  User: InterestUser,
  Content: InterestContent,
}
